import { Controller } from "@hotwired/stimulus"

export default class AutocompleteCreationController extends Controller {
  static targets = ["createInput", "creation"]
  static outlets = ["autocomplete"]

  create() {
    this.createInputTarget.value = this.autocompleteOutlet.inputTarget.value
    this.createInputTarget.form.requestSubmit()
  }

  choose(event) {
    this.autocompleteOutlet.choose(event)
  }

  creationTargetConnected(element) {
    const value = element.dataset.value
    const label = element.dataset.label
    const params = {
      value: value,
      label: label,
    }

    this.autocompleteOutlet.choose({ params: params })
  }
}
